module.exports = __webpack_public_path__ + "fonts/BebasNeue-Regular.woff2?efaa67ae4bf4ee0ff705fa44edb0c41f";